<template>
  <div
    class="rounded-24"
  >
    <div
      class="flex gap-x-1 p-2 bg-bg-base-bg1 items-center col-span-6 sticky top-0 z-11 rounded-full"
    >
      <wui-btn
        data-test="back-to-inner-reactions-btn"
        class="rotate-90"
        prepend-icon="expandMoreBig"
        icon
        :size="32"
        variant="neut"
        state="alpha"
        :title="$t('common.showMenu')"
        @click="$emit('backToInnerReactions')"
      >
        <span class="sr-only select-none">Следующие реакции</span>
      </wui-btn>
      <wui-input
        v-model="customReactionSearchModel"
        type="text"
        :disabled="!customTextReactions.length"
        :placeholder="customTextReactions.length ? $t('common.reactionSearch') : $t('chat.noReactions')"
        with-clear
        prepend-icon="searchM"
      />
    </div>
    <div
      v-if="!customTextReactions.length"
      class="h-[142px] flex flex-col justify-center items-center"
    >
      <p class="text-center text-[40px] text-fg-base-fg14 leading-[56px]">
        Aa
      </p>
      <p class="text-center font-light text-fg-base-fg22 text-1316 mb-4">
        {{ $t('chat.noCreatedReactions') }}
      </p>
      <wui-btn
        :size="32"
        data-test="edit-text-reactions-mode-on-create-btn"
        variant="brand"
        state="filled"
        @click="$emit('editModeOn')"
      >
        {{ $t('common.create') }}
      </wui-btn>
    </div>
    <div
      v-else
    >
      <div class="flex content-start flex-wrap justify-center items-center gap-1 mb-1 overflow-auto h-[108px] max-h-[108px] mx-1">
        <div
          v-for="customTextReaction in customTextReactionsToChoose"
          :key="customTextReaction.emoji"
          data-test="custom-text-reaction-emoji"
          class="text-1316 font-medium cursor-pointer py-1 px-2 rounded-6 transition-all text-fg-base-fg3 hover:bg-surf-neut-soft-hov"
          :class="customTextReaction.isSetByCurrentUser ? 'border border-surf-brand-base-def' : ''"
          @click="$emit('setReaction', customTextReaction)"
        >
          {{ customTextReaction.emoji }}
        </div>
      </div>
      <div class="flex justify-center">
        <wui-btn
          data-test="edit-text-reactions-mode-on-create-btn"
          :size="32"
          variant="brand"
          state="tonal"
          @click="$emit('editModeOn')"
        >
          {{ $t('common.edit') }}
        </wui-btn>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { WuiBtn, WuiInput } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import { ReactionsMap, useReactionsStore } from '@/entities/reaction'

import { EmittedReaction } from '@/shared/types/emitted-reaction'

defineEmits<{
  (event: 'editModeOn'): void
  (event: 'setReaction', value: EmittedReaction): void
  (event: 'backToInnerReactions'): void
}>()

const { customTextReactions } = storeToRefs(useReactionsStore())
const props = defineProps<{
  eventReactions?: ReactionsMap
}>()

const customReactionSearchModel = ref('')

const customTextReactionsToChoose = computed<EmittedReaction[]>(() => {
  return customTextReactions.value.map((emoji) => {
    if (props.eventReactions?.get(emoji)?.isSetByCurrentUser) {
      return { emoji, isSetByCurrentUser: true }
    } else {
      return { emoji, isSetByCurrentUser: false }
    }
  }).filter((reaction) => {
    return reaction.emoji.toLocaleLowerCase().includes(customReactionSearchModel.value.toLocaleLowerCase())
  })
})

</script>
